import React from 'react';
import {
  ArrowDownCircle,
  CheckCircle2,
  Clock3,
  XCircle,
} from 'lucide-react';

interface DepositSummaryProps {
  total: number;
  successful: number;
  pending: number;
  rejected: number;
  loading?: boolean;
}

const formatCurrency = (value: number) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

const DepositSummary: React.FC<DepositSummaryProps> = ({
  total,
  successful,
  pending,
  rejected,
  loading = false,
}) => {
  const cards = [
    {
      title: 'Total Deposits',
      value: total,
      icon: ArrowDownCircle,
      color: 'text-blue-600',
    },
    {
      title: 'Successful',
      value: successful,
      icon: CheckCircle2,
      color: 'text-emerald-600',
    },
    {
      title: 'Pending',
      value: pending,
      icon: Clock3,
      color: 'text-amber-600',
    },
    {
      title: 'Rejected',
      value: rejected,
      icon: XCircle,
      color: 'text-red-600',
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.title}
            className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                  {card.title}
                </p>

                <p className="mt-3 text-2xl font-semibold text-slate-900">
                  {loading
                    ? 'Loading...'
                    : formatCurrency(card.value)}
                </p>
              </div>

              <Icon className={`h-8 w-8 ${card.color}`} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DepositSummary;
